<template>
  <v-layout class="my-3" row>
    <v-flex xs6 md4>
      <div class="palletItemName">
        SO #:
        <span class="palletItemValue">{{ palletBreakdownHeader.psonum }}</span>
      </div>
    </v-flex>
    <v-flex xs6 md4>
      <div class="palletItemName">
        Production Qty:
        <span class="palletItemValue">{{ palletBreakdownHeader.production_qty }}</span>
      </div>
    </v-flex>
    <v-flex xs6 md4>
      <div class="palletItemName">
        P Run #:
        <span class="palletItemValue">{{ palletBreakdownHeader.prunnum }}</span>
      </div>
    </v-flex>
    <v-flex xs6 md4>
      <div class="palletItemName">
        Item Description:
        <span class="palletItemValue">{{ palletBreakdownHeader.item_description }}</span>
      </div>
    </v-flex>
    <v-flex xs6 md4>
      <div class="palletItemName">
        Run #:
        <span class="palletItemValue">{{ palletBreakdownHeader.sprunnum }}</span>
      </div>
    </v-flex>
    <v-flex xs6 md4>
      <div class="palletItemName">
        Item Size:
        <span class="palletItemValue">{{ palletBreakdownHeader.item_size }}</span>
      </div>
    </v-flex>
    <v-flex xs6 md4>
      <div class="palletItemName">
        Item #:
        <span class="palletItemValue">{{ palletBreakdownHeader.item_num }}</span>
      </div>
    </v-flex>
    <v-flex xs6 md4>
      <div class="palletItemName">
        Stretch Info:
        <span class="palletItemValue">{{ palletBreakdownHeader.item_stretching }}</span>
      </div>
    </v-flex>
    <v-flex xs6 md4>
      <div class="palletItemName">
        Stretch Info:
        <span class="palletItemValue">{{ palletBreakdownHeader.item_stretching }}</span>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "LoadPalletHeader",
  props: ["palletBreakdownHeader"],
};
</script>
